module.exports = __webpack_public_path__ + "img/lifeiot-login.ad0a7728.png";